import { Trans } from 'react-i18next'
import { useLocalStorage } from 'react-use'

import { Gallery16, Link16, Upload16 } from '@makyoapp/makyo-icon/icon'
import { Modal, Tabs } from '@makyoapp/makyo-ui'

import {
  FileManagerKind,
  FileManagerProvider,
  FileManagerProviderProps,
  useFileManagerContext,
} from '@/context/FileManagerContext'
import { STORAGE_KEYS } from '@/shared/constants'

import { FileUrlPanel } from './FileUrlPanel'
import { MyFilesPanel } from './MyFilesPanel'
import { UploadPanel } from './UploadPanel'

function FileManagerNavs() {
  const { navLabels } = useFileManagerContext()
  const [, setOpt] = useLocalStorage(STORAGE_KEYS.FILE_MGR_TAB, '', {
    raw: true,
  })

  return (
    <Tabs.Nav className='border-b bdr'>
      <Tabs.NavItem eventKey={FileManagerKind.Upload} onClick={() => setOpt(FileManagerKind.Upload)}>
        <Upload16 />
        <span>{navLabels?.upload || <Trans>Upload</Trans>}</span>
      </Tabs.NavItem>
      <Tabs.NavItem eventKey={FileManagerKind.FileUrl} onClick={() => setOpt(FileManagerKind.FileUrl)}>
        <Link16 />
        <span>{navLabels?.fileUrl || <Trans>File URL</Trans>}</span>
      </Tabs.NavItem>
      <Tabs.NavItem eventKey={FileManagerKind.MyFiles} onClick={() => setOpt(FileManagerKind.MyFiles)}>
        <Gallery16 width={16} height={16} />
        <span>{navLabels?.myFiles || <Trans>My Files</Trans>}</span>
      </Tabs.NavItem>
    </Tabs.Nav>
  )
}

function FileManagerPanels() {
  return (
    <>
      <UploadPanel />
      <FileUrlPanel />
      <MyFilesPanel />
    </>
  )
}

function FileManagerInner() {
  const cachedKey = localStorage.getItem(STORAGE_KEYS.FILE_MGR_TAB)
  const activeKey =
    cachedKey && Object.values(FileManagerKind).includes(cachedKey as FileManagerKind)
      ? cachedKey
      : FileManagerKind.Upload

  return (
    <Tabs defaultActiveKey={activeKey}>
      <FileManagerNavs />
      <FileManagerPanels />
    </Tabs>
  )
}

function FileManagerModalInner() {
  const { show, onHide, title } = useFileManagerContext()
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header onCloseClick={onHide}>{title || <Trans>Select File</Trans>}</Modal.Header>
      <Modal.Body noPadding>
        <div className='modal-md'>
          <FileManagerInner />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export interface FileManagerProps extends FileManagerProviderProps {
  modal?: boolean
}

export function FileManager({ modal = true, ...props }: FileManagerProps) {
  return (
    <FileManagerProvider {...props}>{modal ? <FileManagerModalInner /> : <FileManagerInner />}</FileManagerProvider>
  )
}
